var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGoldLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0L20 10L10 20L0 10L10 0ZM10 3.74109L3.73515 10.0059L10 16.2708L16.2648 10.0059L10 3.74109Z",
    fill: "url(#paint0_linear_318_5450)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87055 10L10 1.87055V0L0 10H1.87055Z",
    fill: "url(#paint1_radial_318_5450)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 1.87109L1.87109 10.0005H3.74164L10.0005 3.74164V1.87109Z",
    fill: "url(#paint2_linear_318_5450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1295 10L10 1.87055V0L20 10H18.1295Z",
    fill: "url(#paint3_linear_318_5450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.87109L18.1295 10.0005H16.2648L10 3.74164V1.87109Z",
    fill: "url(#paint4_linear_318_5450)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87055 10L10 18.1354V20L0 10H1.87055Z",
    fill: "url(#paint5_linear_318_5450)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 18.1354L1.87109 10H3.74164L10.0005 16.2648V18.1354Z",
    fill: "url(#paint6_linear_318_5450)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.147 10L10.0176 18.1354V20L20.0176 10H18.147Z",
    fill: "url(#paint7_linear_318_5450)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.1354L18.1295 10H16.2648L10 16.2648V18.1354Z",
    fill: "url(#paint8_linear_318_5450)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0051 3.74219L3.74023 10.007L10.0051 16.2719L16.2699 10.007L10.0051 3.74219Z",
    fill: "#9A9999"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74609 10.0011L10.0109 3.74219L16.2698 10.0011L10.0109 16.2659L3.74609 10.0011Z",
    fill: "url(#paint9_linear_318_5450)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97266 10.0008L10.0107 5.96875L14.0427 10.0008L10.0107 14.0388L5.97266 10.0008Z",
    fill: "url(#paint10_linear_318_5450)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9984 9.96985L10.0305 5.93778V3.71094L3.76562 9.96985H5.9984Z",
    fill: "url(#paint11_linear_318_5450)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0438 10.0011L10.0117 5.96903V3.74219L16.2706 10.0011H14.0438Z",
    fill: "url(#paint12_linear_318_5450)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97293 9.99219L10.0109 14.0243V16.2511L3.74609 9.99219H5.97293Z",
    fill: "url(#paint13_linear_318_5450)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0438 9.99219L10.0117 14.0243V16.2511L16.2706 9.99219H14.0438Z",
    fill: "url(#paint14_linear_318_5450)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_5450",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_318_5450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5 5) scale(5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_5450",
    x1: 1.87109,
    y1: 5.93285,
    x2: 10.0005,
    y2: 5.93285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E6F9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#475C85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_5450",
    x1: 10,
    y1: 5,
    x2: 20,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_5450",
    x1: 10,
    y1: 5.93285,
    x2: 18.1295,
    y2: 5.93285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57688E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98ADDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_5450",
    x1: 0,
    y1: 15,
    x2: 10,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_318_5450",
    x1: 1.87109,
    y1: 14.0677,
    x2: 10.0005,
    y2: 14.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#455D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95B1DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_318_5450",
    x1: 10.0176,
    y1: 15,
    x2: 20.0176,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_5450",
    x1: 10,
    y1: 14.0677,
    x2: 18.1295,
    y2: 14.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2C8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEE4F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_5450",
    x1: 3.74609,
    y1: 10.0011,
    x2: 16.2698,
    y2: 10.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_5450",
    x1: 5.97266,
    y1: 10.0008,
    x2: 14.0427,
    y2: 10.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_5450",
    x1: 3.76562,
    y1: 6.84039,
    x2: 10.0305,
    y2: 6.84039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_5450",
    x1: 10.0117,
    y1: 6.87164,
    x2: 0.593668,
    y2: 6.87164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_5450",
    x1: -0.000937499,
    y1: 13.1216,
    x2: 10.0109,
    y2: 13.1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF4B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F8EE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F5DF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5DF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F0CC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#E59C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#E3942C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E5A28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_5450",
    x1: 13.1412,
    y1: 13.1216,
    x2: 12.0248,
    y2: 12.0053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1A92C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A65A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoldLoader);
export default __webpack_public_path__ + "static/media/ic-gold-loader.0583df85c3a0e5a5ce71d56e2829d660.svg";
export { ForwardRef as ReactComponent };